var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFavoritesBold = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 29 27"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 2,
  d: "m15.39 1.945 2.703 5.295a3 3 0 0 0 2.201 1.6l5.871.933a1 1 0 0 1 .55 1.694l-4.2 4.207a3 3 0 0 0-.841 2.587l.926 5.872a1 1 0 0 1-1.441 1.047l-5.299-2.695a3 3 0 0 0-2.72 0l-5.3 2.695a1 1 0 0 1-1.44-1.047l.926-5.872a3 3 0 0 0-.84-2.587l-4.201-4.207a1 1 0 0 1 .55-1.694l5.871-.933a3 3 0 0 0 2.201-1.6l2.702-5.295a1 1 0 0 1 1.782 0Z"
})));
export default SvgFavoritesBold;